import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  GenericLoader,
  GenericModal,
  Typography,
} from "../../Components";
import { getLoggedInUser } from "../../utils/helper";
import { ROUTER_PATH } from "../../config";
import { Formik, Form } from "formik";
import { Form as BootstrapForm } from "react-bootstrap";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { saveChatAction } from "../../Redux/actions";
import { translateSuggestedQuestion } from "../../Redux/actions/specializationQuestionsAction";
import { IMAGES } from "../../Assets";

const consultantSpecializationList = [
  { id: 1, title: "Physician", key: "physician" },
  { id: 2, title: "Gastroenterologist", key: "gastroenterologist" },
  { id: 3, title: "Pulmonologist", key: "pulmonologist" },
  { id: 4, title: "Urologist", key: "urologist" },
  { id: 5, title: "Orthopedic", key: "orthopedic" },
];

const avatarOptions = [
  {
    id: 0,
    gender: "male",
    image: IMAGES.MALE_DOCTOR_AVATAR,
    labelEn: "Dr. Ahmad",
    labelAr: "أحمد",
  },
  {
    id: 1,
    gender: "female",
    image: IMAGES.FEMALE_DOCTOR_AVATAR,
    labelEn: "Dr. Elizabeth",
    labelAr: "إليزابيث",
  },
];

export default function SelectLanguage({ show, onHide, chat, gender }) {
  const navigate = useNavigate();
  let dispatch = useDispatch();
  let medUser = getLoggedInUser();

  const [selectedLanguage, setSelectedLanguage] = useState("en");
  const [selectedSpecialization, setSelectedSpecialization] = useState("");
  const [selectedAvatarId, setSelectedAvatarId] = useState(0);

  const aiResponse = useSelector((state) => state.chat);
  const specializationQuestions = useSelector(
    (state) => state.specializationQuestions
  );

  const questionList = specializationQuestions?.TRANSLATE_QUESTIONS?.data;

  function moveToNext(response) {
    if (response.succeeded) {
      const chosen =
        avatarOptions.find((a) => a.id === selectedAvatarId) ||
        avatarOptions[0];
      const selectedSpecialityKey = consultantSpecializationList.find(
        (speciality) => speciality.id === parseInt(selectedSpecialization)
      );
      navigate(ROUTER_PATH.PATIENT_DIAGNOSIS, {
        state: {
          gender: "male",
          language: selectedLanguage,
          specialization: selectedSpecialityKey?.key || "physician",
          suggestedResponse: response?.data,
          avatar: {
            id: chosen.id,
            gender: chosen.gender,
            image: chosen.image,
          },
        },
      });
    } else toast.error(response.message);
    console.log("response", response);
  }

  function getSpecializationAnswerList(id) {
    const selectedSpecialityKey = consultantSpecializationList.find(
      (speciality) => speciality.id === parseInt(id)
    );

    const payload = {
      doctorField: selectedSpecialityKey?.key,
      user_language: selectedLanguage,
      current_index: 0,
      db: {
        fromUserId: medUser?.userId,
        toUserId: "a94ca6cf-8251-44b5-b98c-aadf8393fda6",
        chatId: aiResponse?.CHAT?.[0]?.chatId || aiResponse?.CHAT_ID?.data,
      },
      is_last_message: false,
      is_first_message: true,
    };

    dispatch(translateSuggestedQuestion(payload, moveToNext));
  }

  const handleChatLanguage = async () => {
    if (!selectedLanguage) {
      return toast.error("Please select language");
    }

    if (!selectedSpecialization) {
      return toast.error("Please select specialization");
    }

    if (selectedAvatarId !== 0 && selectedAvatarId !== 1) {
      return toast.error("Please select an avatar");
    }

    getSpecializationAnswerList(selectedSpecialization);
  };

  useEffect(() => {
    if (!aiResponse?.CHAT?.[0]?.chatId || aiResponse?.MESSAGE?.[0]?.chatId) {
      dispatch(
        saveChatAction({
          name: "",
          fromUserId: medUser?.userId,
          toUserId: "a94ca6cf-8251-44b5-b98c-aadf8393fda6",
          roleId: 101,
          questionAnswers: [],
        })
      );
    }
  }, []);

  return (
    <GenericModal
      show={show}
      onHide={onHide}
      size="lg"
      hideFooter={true}
      className="d-flex justify-content-center align-items-center custom-modal-style"
    >
      <Formik
        initialValues={{
          symptoms: Array(questionList?.questions?.length || 0).fill([]),
        }}
        enableReinitialize
        onSubmit={handleChatLanguage}
      >
        {() => (
          <Form className="flex justify-items-center w-100 px-2 px-md-5 p-4 mb-4">
            <Typography
              align="center"
              fontSize="1.2rem"
              fontWeight="500"
              className="p-3 fw-bold"
            >
              Select Preferences to Continue
            </Typography>

            <div>
              <BootstrapForm.Group className="mb-4">
                <BootstrapForm.Label className="fw-bold mb-2">
                  Select Language
                </BootstrapForm.Label>
                <BootstrapForm.Select
                  aria-placeholder="Select"
                  value={selectedLanguage}
                  onChange={(e) => setSelectedLanguage(e.target.value)}
                >
                  <option value="en">English</option>
                  <option value="ar">Arabic</option>
                </BootstrapForm.Select>
              </BootstrapForm.Group>

              <BootstrapForm.Group className="mb-4">
                <BootstrapForm.Label className="fw-bold mb-2">
                  Select Specialization
                </BootstrapForm.Label>
                <BootstrapForm.Select
                  aria-placeholder="Select"
                  value={selectedSpecialization}
                  onChange={(e) => {
                    setSelectedSpecialization(e.target.value);
                  }}
                >
                  <option value="">Select</option>
                  {consultantSpecializationList?.map((item, index) => (
                    <option key={index} value={item?.id}>
                      {item?.title}
                    </option>
                  ))}
                </BootstrapForm.Select>
              </BootstrapForm.Group>

              <BootstrapForm.Group className="mb-4">
                <BootstrapForm.Label className="fw-bold mb-2">
                  Select Avatar
                </BootstrapForm.Label>
                <div className="d-flex gap-3 flex-wrap justify-content-start">
                  {avatarOptions.map((avatar) => {
                    const selected = selectedAvatarId === avatar.id;
                    return (
                      <button
                        key={avatar.id}
                        type="button"
                        onClick={() => setSelectedAvatarId(avatar.id)}
                        className="border-0 bg-transparent p-0"
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="d-flex flex-column align-items-center p-2 rounded"
                          style={{
                            border: selected
                              ? "2px solid #E30020"
                              : "2px solid #e5e5e5",
                            boxShadow: selected
                              ? "0 0 12px rgba(227,0,32,0.25)"
                              : "none",
                            minWidth: "110px",
                          }}
                        >
                          <img
                            src={avatar.image}
                            alt={avatar.labelEn}
                            style={{
                              width: 72,
                              height: 72,
                              borderRadius: "50%",
                              objectFit: "cover",
                            }}
                          />
                          <Typography
                            as="span"
                            className="mt-2 fw-bold"
                            fontSize="0.85rem"
                            color={selected ? "#E30020" : "#4A4F4D"}
                          >
                            {selectedLanguage === "ar"
                              ? avatar.labelAr
                              : avatar.labelEn}
                          </Typography>
                        </div>
                      </button>
                    );
                  })}
                </div>
              </BootstrapForm.Group>
            </div>

            <div className="d-flex gap-3 justify-content-end align-items-end">
              <Button
                minWidth="8rem"
                height="3rem"
                type="submit"
                className={`btn-color ${
                  specializationQuestions?.TRANSLATE_QUESTIONS_LOADING &&
                  "cursor-not-allowed"
                }`}
                disabled={specializationQuestions?.TRANSLATE_QUESTIONS_LOADING}
              >
                <Typography
                  align="center"
                  fontSize="1rem"
                  fontWeight="500"
                  color="white"
                >
                  {specializationQuestions?.TRANSLATE_QUESTIONS_LOADING ? (
                    <GenericLoader />
                  ) : (
                    "Proceed"
                  )}
                </Typography>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </GenericModal>
  );
}
